import { AnyToken } from 'src/common/types/models/Tokens'
import Badge from 'src/common/ui-kit/Badge'
import NumericField from 'src/common/ui-kit/NumericField/NumericField'
import { NumericFieldProps } from 'src/common/ui-kit/NumericField/types'
import TokenIcon from 'src/common/ui-kit/TokenIcon/TokenIcon'
import { big } from 'src/common/utils/big-utils'

interface MaxMinInputProps
  extends Pick<NumericFieldProps<'number'>, 'maxValue' | 'onChange' | 'value'> {
  token?: AnyToken
}

const MaxMinInput: React.FC<MaxMinInputProps> = ({ token, ...inputProps }) => {
  const { onChange, value, maxValue } = inputProps

  const increment = () => {
    if (!maxValue || big(value).plus(1).gt(maxValue)) return
    onChange?.(value + 1)
  }

  const decrement = () => {
    if (big(value).minus(1).lt(0)) return
    onChange?.(value - 1)
  }

  const max = () => {
    if (maxValue === undefined) return
    onChange?.(Number(maxValue.toString()))
  }

  return (
    <div className='flex flex-row border border-primary rounded gap-2 h-10 items-center px-4'>
      <div className='flex flex-row gap-2 min-w-fit'>
        <TokenIcon size={24} token={token} />
        <span className='modal-description'>{token?.symbol}</span>
      </div>

      <NumericField
        className='w-full'
        type='number'
        variant='text'
        hideError
        inputProps={{
          className: 'text-right',
        }}
        {...inputProps}
      />

      <div className='flex flex-col gap-1'>
        <Badge
          color='secondary'
          size='sm'
          className='text-main-accent rounded-full p-0'
          onClick={increment}
          style={{ lineHeight: '10px', width: '12px', height: '12px' }}
        >
          <div style={{ lineHeight: '10px', height: '12px' }}>+</div>
        </Badge>
        <Badge
          color='secondary'
          size='sm'
          className='text-main-accent rounded-full p-0'
          onClick={decrement}
          style={{ lineHeight: '10px', width: '12px', height: '12px' }}
        >
          <div style={{ lineHeight: '10px', height: '12px' }}>-</div>
        </Badge>
      </div>

      <Badge
        color='secondary'
        size='sm'
        className='text-main-accent rounded-full p-0 ml-2'
        onClick={max}
        style={{ lineHeight: '10px', width: '12px', height: '12px' }}
      >
        <div style={{ lineHeight: '10px', height: '12px' }}>Max</div>
      </Badge>
    </div>
  )
}

export default MaxMinInput
